@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-toolbar>
  <mat-icon mat-list-icon>person_add</mat-icon>
  <span class="container-fluid">
    <h1>
      {{ 'USER_MANAGEMENT.TITLE' | transloco }}
    </h1>
  </span>
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <form [formGroup]="userForm" (ngSubmit)="saveChanges()">
    <!-- First Name -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>
        {{ 'USER_MANAGEMENT.FIRSTNAME' | transloco }}
      </mat-label>
      <input matInput [placeholder]="'USER_MANAGEMENT.FIRSTNAME' | transloco" formControlName="firstname">
      <mat-icon matSuffix>person</mat-icon>
      @if (userForm.get('firstname')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.FIRSTNAME' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <!-- Last Name -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label> {{ 'USER_MANAGEMENT.LASTNAME' | transloco }}
      </mat-label>
      <input matInput formControlName="lastname">
      <mat-icon matSuffix>person</mat-icon>
      @if (userForm.get('lastname')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.LASTNAME' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'LOGIN.LANGUAGE' | transloco }}</mat-label>
      <mat-select formControlName="language">
        @for (lang of languages; track lang) {
          <mat-option [value]="lang.value">
            {{ lang.viewValue }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Email -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'USER_MANAGEMENT.EMAIL' | transloco }}</mat-label>
      <input matInput type="email" [placeholder]="'USER_MANAGEMENT.EMAIL' | transloco" formControlName="email">
      <mat-icon matSuffix>email</mat-icon>
      @if (userForm.get('email')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.EMAIL' | transloco) } }}
        </mat-error>
      }
      @if (userForm.get('email')?.hasError('email')) {
        <mat-error>
          {{ 'FORM.VALIDATION.EMAIL' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <!-- Cellphone -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'USER_MANAGEMENT.CELLPHONE' | transloco }}</mat-label>
      <input matInput type="tel" [placeholder]="'USER_MANAGEMENT.CELLPHONE' | transloco"
        formControlName="cellphone">
      <mat-icon matSuffix>phone</mat-icon>
      @if (userForm.get('cellphone')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.CELLPHONE' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <!-- SMS Verification -->
    <div class="mb-3">
      <mat-checkbox formControlName="smsVerification">
        {{ 'USER_MANAGEMENT.SMS_VERIFICATION' | transloco }}
      </mat-checkbox>
    </div>

    <!-- Membership Type -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label class="label-margin-left">
        {{ 'USER_MANAGEMENT.MEMBERSHIP_TYPE' | transloco }}
      </mat-label>
      <mat-select formControlName="membershipType" multiple>
        @for (type of memberShipTypes; track type) {
          <mat-option [value]="type.id">
            {{type.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" [align]="'end'">
  <button mat-button mat-dialog-close>{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-button mat-raised-button color="primary" type="submit" (click)="saveChanges()">
    {{ 'USER_MANAGEMENT.SAVE_CHANGES' | transloco }}
  </button>
</mat-dialog-actions>